<mat-spinner color="primary" [diameter]="30" mode="indeterminate" class="d-inline-block"></mat-spinner>